import { makeBaseSvgIconProps } from 'components/icons/_utils/makeBaseSvgIconProps'

export const IconSprayRecord = () => {
  return (
    <svg {...makeBaseSvgIconProps('0 0 20 20')}>
      <path
        d="M18.6067 4.59591L9.626 8.4371C9.34028 8.5593 9.15617 8.84143 9.15934 9.15216C9.16247 9.45889 9.34755 9.73444 9.63031 9.85335L18.6124 13.6306C19.2714 13.9077 20 13.4238 20 12.7088V5.51534C20 4.79774 19.2665 4.31371 18.6067 4.59591Z"
        fill="white"
      />
      <path
        d="M5.21643 8.27325C5.21643 7.53803 5.81245 6.94202 6.54767 6.94202C7.28289 6.94202 7.87891 7.53803 7.87891 8.27325V12.5786H5.21643V8.27325Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.334 15.9128C10.4419 14.1773 8.63352 12.99 6.54785 12.99C4.46218 12.99 2.65381 14.1773 1.76172 15.9128H0.212969C1.19719 13.3751 3.66235 11.5759 6.54773 11.5759C9.43311 11.5759 11.8983 13.3751 12.8825 15.9128H11.334Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1354 16.6603C12.379 13.7392 9.72529 11.5819 6.56771 11.5819C3.41012 11.5819 0.756396 13.7392 -2.43903e-06 16.6603H13.1354Z"
        fill="white"
      />
    </svg>
  )
}
